import { createUseStyles } from 'react-jss';

export const AccountQAStyles = createUseStyles({
  radioButtonStyles: {
    '& label span': {
      transition: 'background .02s',
      transform: '.2s',
      border: '1px solid #0032a0',
    },
    '& input[type="radio"] + label span:hover, input[type="radio"] + label:hover span':
      {
        transform: 'scale(1.2)',
      },
    '& .checked-span:checked + label span': {
      backgroundColor: '#0032a0',
      boxShadow: '0px 0px 0px 2px white inset',
    },
  },
  radioDisabledButtonStyles: {
    '& label span': {
      transition: 'background .02s',
      transform: '.2s',
      border: '1px solid #0032a0',
    },
    '& input[type="radio"] + label span:hover, input[type="radio"] + label:hover span':
      {
        cursor: 'not-allowed',
      },
  },
  saveOrangeColour: {
    backgroundColor: '#fe50002e',
    width: '74px',
    padding: '0px 7px',
  },
  bgSizePosition: {
    backgroundSize: '60%',
    backgroundPosition: '-37% 10%',
    backgroundRepeat: 'no-repeat',
  },
  arrowUp: {
    width: '0',
    height: '0',
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderBottom: '10px solid white',
  },
  lensesBg: {
    backgroundImage: "url('/images/quick-action-lenses.png')",
  },
  dropBg: {
    backgroundImage: "url('/images/drop-quick.png')",
  },
  blgBg: {
    backgroundImage: "url('/images/blg-quick.png')",
  },
  ordersBg: {
    backgroundImage: "url('/images/product-order-history.png')",
  },
  opacityBgOne: {
    backgroundColor: '#F8F8F8',
  },
});
